module.exports = __webpack_public_path__ + "static/media/bg-with-road.7ce485e4.jpg";